import React from 'react';
import './Awards.css';

// --- ICONS ---
// Using a popular icon library for easy integration.
// Make sure to install it: npm install react-icons
import { FaStar, FaGoogle, FaTrophy, FaAward } from 'react-icons/fa'; // <-- Add FaAward here
import { SiG2, SiTrustpilot } from 'react-icons/si'; // <-- Remove SiClutch

// --- ASSETS ---
import cispImage from '../assets/cisp.PNG';
import isoImage from '../assets/iso.PNG';
import ciscoImage from '../assets/cisco.PNG';

// --- DATA ARRAYS ---

// 1. New: Data for Company Badges
const companyBadgesData = [
  {
    name: 'Clutch',
    icon: <FaAward />,
    description: 'Recognized as a leading B2B service provider.',
    color: '#E44931'
  },
  {
    name: 'G2',
    icon: <SiG2 />,
    description: 'Top-rated software and services based on user reviews.',
    color: '#F8542A'
  },
  {
    name: 'Trustpilot',
    icon: <SiTrustpilot />,
    description: 'Rated "Excellent" by our valued customers worldwide.',
    color: '#00B67A'
  },
  {
    name: 'Google Reviews',
    icon: <FaGoogle />,
    description: 'Consistently high ratings on the world’s most trusted platform.',
    color: '#4285F4'
  },
];

// 2. Existing: Data for CEO's Certifications
const ceoCertificationsData = [
  {
    title: 'Certified Information Systems Security Professional (CISSP)',
    issuer: 'Issued by: (ISC)² / ANAB',
    description: 'A globally recognized credential validating elite cybersecurity expertise and the ability to manage a best-in-class cybersecurity program.',
    image: cispImage
  },
  {
    title: 'ISO/IEC 27001:2022 Lead Auditor',
    issuer: 'Issued by: Mastermind Assurance',
    description: 'Certifies the expertise to audit an Information Security Management System (ISMS), ensuring robust data protection and compliance.',
    image: isoImage
  },
  {
    title: 'Cisco Certified Specialist – Security Core',
    issuer: 'Issued by: Cisco',
    description: 'Validates advanced skills in core security technologies, including network, cloud, and content security solutions.',
    image: ciscoImage
  }
];


// --- COMPONENT ---

const Awards = () => {
  return (
    <div className="awards-page-container">

      {/* SECTION 1: COMPANY AWARDS */}
      <section className="company-badges-section">
        <div className="section-container">
          <div className="section-header">
            <h2>Our Company Accolades</h2>
            <p>We are proud to be recognized by leading platforms for our commitment to quality and client satisfaction.</p>
          </div>
          <div className="badges-grid">
            {companyBadgesData.map((badge, index) => (
              <div className="badge-card" key={index}>
                <div className="badge-icon" style={{ color: badge.color }}>
                  {badge.icon}
                </div>
                <h3 className="badge-name">{badge.name}</h3>
                <p className="badge-description">{badge.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
       <hr className="section-divider" />

      {/* SECTION 2: CEO CERTIFICATIONS */}
      <section className="certifications-section">
        <div className="section-container">
          <div className="section-header">
            <h2>A Commitment to Excellence from Our CEO</h2>
            <p>
              Our CEO’s personal achievements and professional accreditations demonstrate a strong commitment to expertise, security, and compliance best practices.
            </p>
          </div>
          <div className="certifications-grid">
            {ceoCertificationsData.map((cert, index) => (
              <div className="certification-card" key={index}>
                <div className="cert-image-wrapper">
                  <img src={cert.image} alt={`${cert.title} Certificate`} className="cert-image" />
                </div>
                <div className="cert-details">
                  <h3 className="cert-title">{cert.title}</h3>
                  <p className="cert-issuer">{cert.issuer}</p>
                  <p className="cert-description">{cert.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

export default Awards;